module.exports = __webpack_public_path__ + "static/start_question_bg-0d0313dab0f7882d3498e54803026766.svg";